class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    setTimeout(function(){
      const isFindMyDevicePage = window.location.pathname === '/products/find-your-mobile-device-here';
      if(isFindMyDevicePage){
        const selectedImg = document.querySelector('.product_variant_image.selected').getAttribute('src');
        if(selectedImg){
          const lineItem = document.querySelector(`.cart-item__media[line_item_id="${parsedState.id}"] img`);
          lineItem?.setAttribute('src', selectedImg);
        }
      }
    }, 1000)
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CustomVariantChanger extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    const selectOption = this.querySelector("select");
    if (selectOption) {
      selectOption.addEventListener("change", this.variantChangeDropdown.bind(this));
    }
  }

  async variantChangeDropdown(event) {
    event.preventDefault();

    const oldId = parseInt(this.dataset.itemId, 10);
    const quantity = parseInt(this.dataset.quantity, 10) || 1;
    const newId = parseInt(event.target.value, 10);

    let cartData;
    try {
      const cartRes = await fetch('/cart.js');
      cartData = await cartRes.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return;
    }

    let existingQty = 0;
    cartData.items.forEach(item => {
      if (item.variant_id === newId) {
        existingQty += item.quantity;
      }
    });

    const updates = {};
    updates[oldId] = 0;
    updates[newId] = existingQty + quantity;
    const body = {
      updates: updates,
      sections: ['cart-drawer','cart-icon-bubble']
    };

    try {
      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();

    const oldDrawer = document.querySelector('cart-drawer');
    const oldIcon = document.querySelector('#cart-icon-bubble');
    const newDrawer = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
    const newIcon = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    oldDrawer.innerHTML = newDrawer.innerHTML;
    oldIcon.innerHTML = newIcon.innerHTML;
    document.querySelector('cart-drawer').classList.toggle('is-empty', data.item_count === 0);

    } catch (error) {
      console.error("Error updating cart:", error);
    } finally {
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
    }
  }
}

customElements.define('custom-variant-changer', CustomVariantChanger);

  class AddBundleCart extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector("button");
      if (this.button) {
        this.button.addEventListener("click", this.handleClick);
      }
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener("click", this.handleClick);
      }
    }

    handleClick(event) {
      event.preventDefault();

      // const variant_id_container = document.querySelectorAll('.skin_with_straps .free_strap_birthday_sale_container .birthday_strap_grid');
      const variant_id_container = document.querySelector('.limited_time_offer_product_add-to-cart');
      this.querySelector('.cart_drawer_offer_claim_main')?.classList.add('hidden');
      this.querySelector('.rogue_red_offer_atc-btn .text_btn_atc')?.classList.add('hidden');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      let allVariantId = this.getAttribute('variant_ids');
      const multipleVariantId = allVariantId.includes(',');

      // if(variant_id_container){
      let items, formData;
      
      if (multipleVariantId) {
        const variantIds = allVariantId.split(',');
        items = variantIds.map(id => ({
          id: parseInt(id.trim()), 
          quantity: 1 
        }));
      } else {
        items = [
          { id: parseInt(allVariantId.trim()), quantity: 1 }
        ];
      }
      
      formData = {
        items: items,
        sections: ["cart-drawer", "cart-icon-bubble"],
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(resp => resp.json())
      .then(result => {
        const oldDrawerItems = document.querySelector('cart-drawer');
        const oldIcon = document.querySelector('#cart-icon-bubble');
        const newDrawerItems = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
        const newIcon = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if(newDrawerItems) oldDrawerItems.innerHTML = newDrawerItems.innerHTML;
        if(newIcon) oldIcon.innerHTML = newIcon.innerHTML;
        document.querySelector('cart-drawer').classList.toggle('is-empty', result.item_count === 0);        
      })
      .catch(err => console.log('Error:', err.message))
      .finally(() => {
          fireConfetti({
            particleCount: 400,
            spread: 50,
            origin: { x: 0.5, y: 0.5 }
          });
        })
      }
    }
  // }

  customElements.define("add-bundle-cart", AddBundleCart);


